import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import { Typography } from '@mui/material';
import Link from "@material-ui/core/Link";
import FacebookIcon from '@material-ui/icons/Facebook';
import greyLog from '../assets/static/images/squareandcompasses.png'
import Grid from '@material-ui/core/Grid';
import { COMPANY_NAME_LTD,
  COMPANY_ADD_LINE_1,
  COMPANY_ADD_LINE_2,
  COMPANY_ADD_LINE_2a,
  COMPANY_ADD_LINE_3,
  THIRD_FONT_COLOR,
  COMPANY_FACEBOOK_URL
} from "../shared/consts";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: '#ecf4fa',
    padding: theme.spacing(6),
    color: theme.palette.background.paper,
  },
  root: {
      margin: theme.spacing(1),
      width: '25ch',
  },
  preFooter: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(4),
    color: '#f3f3f3',
    marginTop: '80px',
  },
}));

function Copyright() {
  return (
    <div style={{ textAlign: 'center' }}>
      <Typography
        variant="body2"
        sx={{
          display: 'inline-block', // Makes background hug the text
          backgroundColor: '#6e6e6e', // Black background for the text
          color: 'white', // White text for contrast
          padding: '4px 4px', // Small padding for aesthetics
          fontWeight: 'bold',
          borderRadius: '6px', // Slightly rounded corners
        }}
      >
        {'Copyright © '}
        <Link
          color="inherit"
          href="https://beeframeworks.co.uk/"
          sx={{ color: 'inherit', textDecoration: 'underline' }}
        >
          Bee Frameworks
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
  </div>
  );
}

function Footer() {
  const classes = useStyles();

  const handleMenuClose = (social) => {
    console.log(social)
    social === 'facebook' ? window.open('https://www.facebook.com', '_blank')
      : window.open('https://twitter.com', '_blank')
  };

  let history = useHistory();

  function handleNavigate() {
    history.push({
      pathname: '/about-us',
    });
  }

  function handleContact() {
    history.push({
      pathname: '/contact',
    });
  }

  function handleNavigateToJobApplication() {
    history.push({
      pathname: '/job-application',
    });
  }

  return (
    <div>
      <footer className={classes.preFooter}>
        <Typography variant="h5"
                    align="center"
                    color="textPrimary"
                    gutterBottom>
          Connect with us
        </Typography>
        <div style={{textAlign: 'center', margin: '20px'}}>
          <FacebookIcon
            onClick={() => handleMenuClose('facebook')}
            htmlColor="#1877F2"
            style={{ margin: '15px', width: '50px', height: '50px', cursor: 'pointer' }}
          />
          {/*<TwitterIcon  onClick={() => handleMenuClose('twitter')}*/}
          {/*              style={{ margin: '15px', width: '50px', height: '50px', cursor: 'pointer'}}/>*/}
        </div>

      </footer>
      {/* Footer */}
      <footer className={classes.footer}>
        <Grid container spacing={2} justify="center">
          <Grid item xs={12} sm={4}>
            <div style={{color: THIRD_FONT_COLOR, textAlign: 'center'}}>
              <div
                style={{backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  height: '100px',
                  backgroundImage: `url(${greyLog})`,
                  backgroundSize: 'contain',
                  marginBottom: '15px'
                }}
              >
              </div>
              <Typography variant='h6' style={{color: THIRD_FONT_COLOR, fontWeight: 700, fontFamily: 'Bree Serif'}}>
                { COMPANY_NAME_LTD }
              </Typography>
              <Typography variant='h8' style={{color: THIRD_FONT_COLOR, fontSize: '0.8rem'}}>
                {COMPANY_ADD_LINE_1}<br/>
                {COMPANY_ADD_LINE_2} <br/>
                {COMPANY_ADD_LINE_2a}<br/>
                {COMPANY_ADD_LINE_3}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{color: THIRD_FONT_COLOR, textAlign: 'center'}}>

              <div className="heading-with-underline">
                <Typography variant="h5" style={{ fontWeight: 'bold', paddingBottom: '8px' }}>
                  Additional links
                </Typography>
                <div className="custom-hr">
                  <div className="hr-segment-short"></div>
                  <div className="hr-spacer"></div>
                  <div className="hr-segment-long"></div>
                </div>
              </div>
              <div style={{fontSize: '0.8rem'}}>
                <Link style={{cursor: 'pointer'}} onClick={handleNavigate} color="inherit">
                  Freemason Hall
                </Link> <br/><br/>
                <Link style={{cursor: 'pointer'}} onClick={handleNavigate} color="inherit">
                  Charity
                </Link> <br/><br/>
                <Link style={{cursor: 'pointer'}} onClick={handleContact} color="inherit">
                  Get In Touch
                </Link> <br/><br/>
                {/*<Link style={{cursor: 'pointer'}} href="https://Lyorahealthcareservices.co.uk/policies" target="_blank">*/}
                {/*  Policies*/}
                {/*</Link> <br/><br/> <br/>*/}
                {/*<Link style={{cursor: 'pointer'}} onClick={handleNavigateToJobApplication} color="inherit">*/}
                {/*  Apply for jobs*/}
                {/*</Link> <br/><br/>*/}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{color: THIRD_FONT_COLOR, textAlign: 'center'}}>
              <div className="heading-with-underline">
                <Typography variant="h5" style={{ fontWeight: 'bold', paddingBottom: '8px' }}>
                  Social Media
                </Typography>
                <div className="custom-hr">
                  <div className="hr-segment-short"></div>
                  <div className="hr-spacer"></div>
                  <div className="hr-segment-long"></div>
                </div>
              </div>
              <div style={{fontSize: '0.8rem'}}>
                {/*<Link color="inherit" href="https://exukonline.com">*/}
                {/*  LinkedIn*/}
                {/*</Link> */}
                {/*<br/><br/>*/}
                <Link color="inherit" href={COMPANY_FACEBOOK_URL} target="_blank">
                  Facebook
                </Link> <br/><br/>
              </div>
            </div>
          </Grid>
        </Grid>
        <hr style={{marginBottom: '20px', border: '1px solid #f4f9ff', marginTop: '25px'}}/>
        <Copyright />
      </footer>
      {/* End footer */}
    </div>
  )
}

export default Footer;